import * as FileSaver from "file-saver";
import React from "react";
import { Button } from "react-bootstrap";
import * as XLSX from "xlsx";
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
const ExportEvents = ({ events }) => {
  const handleExport = () => {
    let sheet_rows = [];
    sheet_rows.push({
      A: "Email",
      B: "Event Name",
      C: "User Create Time",
      D: "Last updated Time",
      E: "Company",
      F: "State",
      G: "Country",
    });
    for (let event of events) {
      let row = {
        A: event.email,
        B: event.displayName,
        C: event.userCreateTime,
        D: event.lastUpdateTime,
        E: event.company,
        F: event.state,
        G: event.country,
      };
      sheet_rows.push(row);
    }
    let ws = XLSX.utils.json_to_sheet(sheet_rows, {
      header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
      skipHeader: true,
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "Signup Events" + fileExtension);
  };
  return (
    <>
      <Button disabled={!events || events.length == 0} onClick={handleExport}>
        Export
      </Button>
    </>
  );
};

export default ExportEvents;
